import axios from "axios";

export default {
  data() {
    return {
      pressNew: {
        title: "",
        date: null,
        media_type: null,
        scope: "",
        media: "",
        uri: "",
      }
    };
  },

  methods: {
    getPressNew(path) {
      axios
        .get(path)
        .then(response => {
          this.pressNew = response.data;
        })
        .finally(() => (this.load_complete = true))
        .catch(error => {
          console.log(error);
        });
    },
    setBreadcrumb() {
      let item = {
        text: this.pressNew.title,
        disabled: true,
        last: true
      };
      if (
        !this.$route.meta.breadCrumb.some(breadcrumb => {
          return breadcrumb.last === true;
        })
      ) {
        this.$route.meta.breadCrumb.push(item);
      } else {
        this.$route.meta.breadCrumb.pop();
        this.$route.meta.breadCrumb.push(item);
      }
      this.$store.state.sectionTitle = this.pressNew.title;
    },
    getPressNewWithBreadCrumb(path) {
      axios
        .get(path)
        .then(response => {
          this.pressNew = response.data;
        })
        .finally(() => this.setBreadcrumb())
        .catch(error => {
          console.log(error);
        });
    }
  }
};
